import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  selectFormat,
  sortNumeric,
  Error,
  getMetricForColumn,
} from "components/Utils/Utils.js";

class MarqueeTVads extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable(data, cells) {
    const { title } = this.props;

    const selected_columns = [];

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const total_index = data.findIndex(({ source }) => source === "Total");
    let table_data = data.slice(0);
    const footer_data = table_data.splice(total_index, 1)[0];

    const columns = [
      {
        dataField: "source",
        text: "Source",
        style: { width: "150px", minWidth: "150px", textAlign: "left" },
        headerAlign: "left",
        sort: true,
        footer: footer_data["source"],
      },
      {
        dataField: "impressions",
        text: "IMPs",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
        footer: footer_data["impressions"],
        footerFormatter: (col) => getMetricForColumn(col.footer),
      },
      {
        dataField: "clicks",
        text: "Clicks",
        style: { width: "120px", minWidth: "120px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
        footer: footer_data["clicks"],
        footerFormatter: (col) =>
          getMetricForColumn(col.footer, null, null, col.formatExtraData),
      },
      {
        dataField: "ctr",
        text: "CTR",
        style: { width: "125px", minWidth: "125px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage", format: "%0.00" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "%0.00"),
        sort: true,
        sortFunc: sortNumeric,
        footer: footer_data["ctr"],
        footerFormatter: (col) =>
          getMetricForColumn(col.footer, null, null, col.formatExtraData),
      },
      {
        dataField: "purchases",
        text: "Free Trial Starts",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "number" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
        footer: footer_data["purchases"],
        footerFormatter: (col) =>
          getMetricForColumn(col.footer, null, null, col.formatExtraData),
      },
      {
        dataField: "cost",
        text: "Cost",
        style: { width: "125px", minWidth: "125px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "currency-GB" },
        csvFormatter: (cell) => selectFormat("currency-GB", cell && cell.value),
        sort: true,
        sortFunc: sortNumeric,
        footer: footer_data["cost"],
        footerFormatter: (col) =>
          getMetricForColumn(col.footer, null, null, col.formatExtraData),
      },
      {
        dataField: "acquisition_spend",
        text: "ACQ Spend",
        style: { width: "125px", minWidth: "125px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "currency-GB" },
        csvFormatter: (cell) => selectFormat("currency-GB", cell && cell.value),
        sort: true,
        sortFunc: sortNumeric,
        footer: footer_data["acquisition_spend"],
        footerFormatter: (col) =>
          getMetricForColumn(col.footer, null, null, col.formatExtraData),
      },
      {
        dataField: "acq_cpa",
        text: "ACQ CPA",
        style: { width: "125px", minWidth: "125px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "currency-GB" },
        csvFormatter: (cell) => selectFormat("currency-GB", cell && cell.value),
        sort: true,
        sortFunc: sortNumeric,
        footer: footer_data["acq_cpa"],
        footerFormatter: (col) =>
          getMetricForColumn(col.footer, null, null, col.formatExtraData),
      },
    ];

    cells.forEach((cell, i) => {
      selected_columns.push(columns.find((o) => o.dataField === cell));
    });

    const defaultSorted = [
      {
        dataField: "cost",
        order: "desc",
      },
    ];

    const filename = title.split(" ").join("_") || "spreadsheet";

    return (
      <ToolkitProvider
        keyField="id"
        data={table_data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            footerClasses={"tfoot__tr"}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data, cells } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data.data, cells);
  }
}

export default MarqueeTVads;
